// // Component Libraries
// import LandingNavBar from "../LandingNavBar/LandingNavBar";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useState, useEffect, useRef } from "react";

// //Asset Libraries
// import { ReactComponent as AuthBackgroundImage } from "../../../assets/auth-landing-page-content-v1.svg";
// import { ReactComponent as AuthDelineator } from "../../../assets/auth-text-delineator.svg";
// import GoogleSignInButton from "../GoogleSignInButton/GoogleSignInButton";

// //Design Libraries
// import "./SignUp.scss";

// // API Libraries
// import { useUser } from "../../../model/contexts/user.context";

// //Form Data Initializer
// const defaultFormFields = {
//   email: "",
//   password: "",
//   confirmPassword: "",
// };

// const SignUp = () => {
//   const [formFields, setFormFields] = useState(defaultFormFields);
//   const { email, password, confirmPassword } = formFields;
//   // const [plan, setPlan] = useState("");
//   const [isVerificationSent, setIsVerificationSent] = useState(false);

//   const navigate = useNavigate();
//   const { signUpUser } = useUser();

//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setFormFields({ ...formFields, [name]: value });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     try {
//       if (email === "") {
//         alert("Please Input a Valid Email!");
//         return;
//       }

//       if (password === "") {
//         alert("Please Input a Password!");
//         return;
//       }

//       if (confirmPassword === "") {
//         alert("Please Confirm Your Password Entry!");
//         return;
//       }

//       if (!email.includes("@")) {
//         alert("Please make sure you input a valid email!");
//         return;
//       }

//       if (password !== confirmPassword) {
//         alert("Please check the password that you entered and confirmed!");
//         return;
//       }

//       await signUpUser({
//         email,
//         password,
//         plan: "freemium",
//       });

//       resetFormInput();
//       setIsVerificationSent(true);

//       setTimeout(() => {
//         navigate("/auth");
//       }, 6000);
//     } catch (error) {
//       console.error("Sign up error:", error);

//       alert(
//         error?.response?.data?.error ||
//           error?.response?.data?.message ||
//           error?.message ||
//           "Something went wrong on our end!",
//       );
//     }
//   };

//   const resetFormInput = () => {
//     setFormFields(defaultFormFields);
//   };

//   return (
//     <div className="auth-sign-up-container">
//       <LandingNavBar />
//       <div className="auth-sign-up-landing-content-container">
//         {!isVerificationSent ? (
//           <>
//             {/* Sign Up Welcome Section */}
//             <div className="sign-up-welcome-content-container">
//               <p className="landing-content-font-v1 sign-up-text">
//                 The Modern Task Management Platform
//               </p>
//               <p className="landing-content-font-v2 sign-up-text">
//                 We keep you posted
//               </p>
//               {/* <AuthBackgroundImage className="auth-marketing-background-image" /> */}
//             </div>

//             {/* Sign Up Form */}
//             <div className="auth-sign-up-form-outer-container">
//               <div className="auth-sign-up-form-inner-container">
//                 <div className="auth-main-login-container">
//                   <div className="auth-main-login-form-container">
//                     {/* Email Field */}
//                     <div className="auth-form-item">
//                       <p className="auth-form-text"> Preferred Email</p>
//                       <input
//                         className="auth-form-input-field"
//                         type="email"
//                         required={true}
//                         name="email"
//                         onChange={handleChange}
//                         value={email}
//                       />
//                     </div>

//                     {/* Password Field */}
//                     <div className="auth-form-item">
//                       <p className="auth-form-text"> Password </p>
//                       <input
//                         className="auth-form-input-field"
//                         type="password"
//                         required={true}
//                         name="password"
//                         onChange={handleChange}
//                         value={password}
//                       />
//                     </div>

//                     {/* Confirm Password Field */}
//                     <div className="auth-form-item">
//                       <p className="auth-form-text"> Confirmed Password </p>
//                       <input
//                         className="auth-form-input-field"
//                         type="password"
//                         required={true}
//                         name="confirmPassword"
//                         onChange={handleChange}
//                         value={confirmPassword}
//                       />
//                     </div>

//                     {/* Submit Button */}
//                     <div className="auth-form-item">
//                       <div className="auth-form-button" onClick={handleSubmit}>
//                         Sign Up
//                       </div>
//                       <AuthDelineator className="auth-delineator" />
//                     </div>
//                   </div>
//                 </div>

//                 {/* Alternative Login */}
//                 <div className="auth-alternative-login-container">
//                   <div className="auth-alternative-login-inner-container">
//                     <GoogleSignInButton
//                       mode="signup"
//                       resetFormInput={resetFormInput}
//                     />

//                     {/* Existing Account Link */}
//                     <div className="auth-sign-up-alternative-text">
//                       If you have an account already, please sign in
//                       <Link className="auth-sign-up-link-text" to="/auth">
//                         here
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           // Verification Message
//           <div className="sign-up-verification-message">
//             <h1>{"We've just sent you a verification email 📩"}</h1>
//             <h2>
//               {
//                 "Please click the link inside to verify your account and unlock access by signing in."
//               }
//             </h2>
//             <h2>
//               {
//                 "If you don't see it in your inbox within a few minutes, try checking your spam or junk folder — sometimes it hides there."
//               }
//             </h2>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SignUp;

import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import LandingNavBar from "../LandingNavBar/LandingNavBar";
import GoogleSignInButton from "../GoogleSignInButton/GoogleSignInButton";

import { ReactComponent as AuthDelineator } from "../../../assets/auth-text-delineator.svg";

import { useUser } from "../../../model/contexts/user.context";

import "./SignUp.scss";

const defaultFormFields = {
  email: "",
  password: "",
  confirmPassword: "",
};

const SignUp = () => {
  const [formFields, setFormFields] = useState(defaultFormFields);
  const [loading, setLoading] = useState(false);
  const [isVerificationSent, setIsVerificationSent] = useState(false);

  const { email, password, confirmPassword } = formFields;

  const navigate = useNavigate();
  const { signUpUser } = useUser();

  const resetFormInput = () => {
    setFormFields(defaultFormFields);
  };

  useEffect(() => {
    if (!isVerificationSent) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      navigate("/auth");
    }, 6000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isVerificationSent, navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields((currentFields) => ({
      ...currentFields,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
      alert("Please enter your email.");
      return;
    }

    if (!normalizedEmail.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!password.trim()) {
      alert("Please enter a password.");
      return;
    }

    if (!confirmPassword.trim()) {
      alert("Please confirm your password.");
      return;
    }

    if (password !== confirmPassword) {
      alert("Your passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      await signUpUser({
        email: normalizedEmail,
        password,
        plan: "freemium",
      });

      resetFormInput();
      setIsVerificationSent(true);
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Unable to create your account. Please try again.";

      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sign-up-page">
      <LandingNavBar />

      <main className="sign-up-page__content">
        {!isVerificationSent ? (
          <>
            <section className="sign-up-page__welcome">
              <p className="sign-up-page__headline">
                The Modern Task Management Platform
              </p>

              <p className="sign-up-page__subheadline">We keep you posted</p>
            </section>

            <section className="sign-up-page__panel">
              <div className="sign-up-page__card">
                <div className="sign-up-page__form-area">
                  <form
                    className="sign-up-page__form"
                    onSubmit={handleSubmit}
                    noValidate
                  >
                    <div className="sign-up-page__field">
                      <label
                        className="sign-up-page__label"
                        htmlFor="sign-up-email"
                      >
                        Preferred Email
                      </label>

                      <input
                        id="sign-up-email"
                        className="sign-up-page__input"
                        type="email"
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={handleChange}
                        disabled={loading}
                        required
                      />
                    </div>

                    <div className="sign-up-page__field">
                      <label
                        className="sign-up-page__label"
                        htmlFor="sign-up-password"
                      >
                        Password
                      </label>

                      <input
                        id="sign-up-password"
                        className="sign-up-page__input"
                        type="password"
                        name="password"
                        autoComplete="new-password"
                        value={password}
                        onChange={handleChange}
                        disabled={loading}
                        required
                      />
                    </div>

                    <div className="sign-up-page__field">
                      <label
                        className="sign-up-page__label"
                        htmlFor="sign-up-confirm-password"
                      >
                        Confirm Password
                      </label>

                      <input
                        id="sign-up-confirm-password"
                        className="sign-up-page__input"
                        type="password"
                        name="confirmPassword"
                        autoComplete="new-password"
                        value={confirmPassword}
                        onChange={handleChange}
                        disabled={loading}
                        required
                      />
                    </div>

                    <button
                      className="sign-up-page__submit"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Creating Account..." : "Sign Up"}
                    </button>

                    <div className="sign-up-page__divider">
                      <AuthDelineator
                        className="sign-up-page__divider-image"
                        aria-hidden="true"
                      />
                    </div>
                  </form>
                </div>

                <div className="sign-up-page__alternative-area">
                  <div className="sign-up-page__alternative-content">
                    <div className="sign-up-page__google-wrapper">
                      <GoogleSignInButton
                        mode="signup"
                        resetFormInput={resetFormInput}
                      />
                    </div>

                    <p className="sign-up-page__alternative-text">
                      If you already have an account, please sign in{" "}
                      <Link className="sign-up-page__link" to="/auth">
                        here
                      </Link>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : (
          <section
            className="sign-up-page__verification"
            role="status"
            aria-live="polite"
          >
            <h1>We&apos;ve sent you a verification email 📩</h1>

            <h2>
              Click the link inside the email to verify your account. You can
              then return and sign in.
            </h2>

            <h2>
              If you do not see it within a few minutes, check your spam or junk
              folder.
            </h2>
          </section>
        )}
      </main>
    </div>
  );
};

export default SignUp;
